// @genesys-custom-file
import * as React from 'react';


import { Button } from './button';
import { Spinner } from './spinner';

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingText?: string;
  variant?: React.ComponentProps<typeof Button>['variant'];
  size?: React.ComponentProps<typeof Button>['size'];
  asChild?: boolean;
}

export const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ className, children, isLoading = false, loadingText, disabled, variant, size, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={className}
        disabled={isLoading || disabled}
        variant={variant}
        size={size}
        {...props}
      >
        {isLoading ? (
          <React.Fragment>
            <Spinner size="sm" className="mr-2" />
            {loadingText ?? children}
          </React.Fragment>
        ) : (
          children
        )}
      </Button>
    );
  }
);

LoadingButton.displayName = 'LoadingButton';